/**
 * マップページのルートコンポーネント、組織ごとにコピーして拡張
 *
 * テンプレートはJinjaの以下と紐づく
 * templates/organizations/{...}/map.html > templates/default/map.html
 *
 * 特にカスタマイズが不要なら複製は不要
 */
import { defineComponent, ref, onMounted } from 'vue'
import Page from '@/services/Page'
import MapPage from "@/organizations/_default/map"
import { overrideFetchPointsByGeohash, overrideGetPointsUrl, overrideHeaderStyle } from './overrides'
import HorizontalFilter from "./HorizontalFilter.vue"

export default defineComponent({
  extends: MapPage,
  components: { HorizontalFilter },
  setup(props, context) {
    overrideFetchPointsByGeohash()
    overrideGetPointsUrl()
    
    const page = MapPage.setup(props, context)
    const isInternal = storelocator.path.id == "internal"

    // 絞り込みUIをヨコに変更するため、必要な絞り込み設定のみ抽出する
    const filter = [...storelocator.search_conditions[0].children, storelocator.search_conditions[1]]

    // 新着一覧ページへの遷移
    const pointPageUrl = ref(Page.getPointsUrl())

    onMounted(() => {
      overrideHeaderStyle(isInternal)
    })

    return {
      ...page,
      filter,
      isInternal,
      pointPageUrl
    }
  }
})